import * as Yup from "yup"

export const validationSchema = Yup.object({
    answer: Yup.string()
    .required(''),
});